import { gql } from '@apollo/client';

export default gql`
  query loyaltyMemberBenefits($membershipNumber: String!, $startDate: String, $endDate: String) {
    loyaltyMemberBenefits(membershipNumber: $membershipNumber, startDate: $startDate, endDate: $endDate) {
      id
      benefitStatus
      benefitName
      transactionJournal
      startDate
      endDate
      cancellationReason
      bookingReference
      benefitRedemptionDate
      comments
    }
  }
`;
